import React from 'react'
import { RiInstagramFill, RiTwitterFill, RiYoutubeFill } from 'react-icons/ri'
import { AiOutlineMail, AiOutlineHome, AiOutlinePhone } from 'react-icons/ai'
import Logo from "../img/Cedonia_white.png"

export default function Footer() {
    return (
        <footer className="bg-zinc-950 text-white">
            <nav className="px-4 py-12 sm:px-6 lg:px-8">
                <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-[1.2fr_1fr_auto] lg:items-start">
                    <div className='flex flex-col items-start'>
                        <span className="text-3xl font-bold tracking-tight">Cedonia</span>
                        <span className="mt-2 max-w-sm text-sm leading-6 text-zinc-400">Custom machining and project management since 1996</span>
                        <img src={Logo} alt="Logo" width="200px" className='mt-6' />
                    </div>
                    <div>
                        <div className='flex flex-col gap-4'>
                            <div className='flex items-start gap-3 text-sm leading-6 text-zinc-300'>
                                <AiOutlineHome className='mt-1 shrink-0 text-red-500' size={"1.5em"} />
                                <p>
                                    Meet Us:
                                    2405 Lucknow Drive,
                                    Mississauga, On, L5S 1H9
                                </p>
                            </div>
                            <div className='flex items-center gap-3 text-sm text-zinc-300'>
                                <AiOutlinePhone className='text-red-500' size={"1.5em"} />
                                <p>
                                    Call Us:
                                </p>
                                <a href="tel:905-564-2033" className='text-white transition hover:text-red-400'>
                                    905-564-2033
                                </a>
                            </div>
                            <div className='flex items-center gap-3 text-sm text-zinc-300'>
                                <AiOutlineMail className='text-red-500' size={"1.5em"} />
                                <p>
                                    Mail Us:
                                </p>
                                <a href="mailto:inquiries@cedonia.ca" className='text-white transition hover:text-red-400'>
                                    inquiries@cedonia.ca
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='font-bold'>
                        <div className='flex items-center gap-2'>
                            <button className='rounded-md border border-white/10 p-3 text-zinc-300 transition hover:-translate-y-0.5 hover:border-red-500 hover:bg-red-600 hover:text-white' type="button" aria-label="Instagram"><RiInstagramFill size={"1.5em"} /></button>
                            <button className='rounded-md border border-white/10 p-3 text-zinc-300 transition hover:-translate-y-0.5 hover:border-red-500 hover:bg-red-600 hover:text-white' type="button" aria-label="Twitter"><RiTwitterFill size={"1.5em"} /></button>
                            <button className='rounded-md border border-white/10 p-3 text-zinc-300 transition hover:-translate-y-0.5 hover:border-red-500 hover:bg-red-600 hover:text-white' type="button" aria-label="YouTube"><RiYoutubeFill size={"1.5em"} /></button>
                        </div>
                    </div>
                </div>
                <p className='mx-auto mt-12 max-w-7xl border-t border-white/10 pt-6 text-center text-sm font-bold text-zinc-500'>Copyright Cedonia INC All rights reserved.</p>
            </nav>
        </footer>
    )
}
